export const LIMIT_SAVEDFORMS = 10;
